import { fetchApiKey } from "./apiUtils";

// Turns a { lat, lng } into a human street address via Google's Geocoding API,
// reusing the same key the address autocomplete uses (fetched through our
// auth-gated getApiKey function). Powers "Locate me" - starting an event at
// wherever you physically are, without knowing the address.
//
// Note: the Geocoding API must be enabled for this key in the Google Cloud
// console (it's a separate API from Places/Maps JS). If it isn't, this throws
// and the caller falls back to manual address selection.
export async function reverseGeocode({ lat, lng }) {
  const key = await fetchApiKey();
  const url =
    `https://maps.googleapis.com/maps/api/geocode/json` +
    `?latlng=${lat},${lng}&key=${key}`;
  const resp = await fetch(url);
  if (!resp.ok) {
    throw new Error("Couldn't look up your address right now.");
  }
  const data = await resp.json();
  if (data.status !== "OK" || !data.results || data.results.length === 0) {
    throw new Error("Couldn't find an address for your location.");
  }
  // Prefer the most precise match: an exact rooftop point, then a real street
  // address, before falling back to Google's first (broadest) result.
  const results = data.results;
  const best =
    results.find((r) => r.geometry?.location_type === "ROOFTOP") ||
    results.find((r) => (r.types || []).includes("street_address")) ||
    results[0];
  return best.formatted_address;
}
